package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class DashboardStatisticsResponse(
    val timestamp: String = "",
    val scope: String = "",
    val statistics: DashboardStatisticsMetrics = DashboardStatisticsMetrics()
)

@Serializable
data class DashboardStatisticsMetrics(
    val subjects: DashboardStatisticsCountMetrics = DashboardStatisticsCountMetrics(),
    val classes: DashboardStatisticsCountMetrics = DashboardStatisticsCountMetrics(),
    val staff: DashboardStatisticsStaffMetrics = DashboardStatisticsStaffMetrics(),
    val students: DashboardStatisticsCountMetrics = DashboardStatisticsCountMetrics(),
    val parents: DashboardStatisticsCountMetrics = DashboardStatisticsCountMetrics(),
    @SerialName("it_staff")
    val itStaff: DashboardStatisticsCountMetrics = DashboardStatisticsCountMetrics(),
    @SerialName("support_tickets")
    val supportTickets: DashboardStatisticsTicketMetrics = DashboardStatisticsTicketMetrics()
)

@Serializable
data class DashboardStatisticsCountMetrics(
    val total: Int = 0,
    val active: Int = 0,
    val inactive: Int = 0,
    val deleted: Int = 0
)

@Serializable
data class DashboardStatisticsTicketMetrics(
    val total: Int = 0,
    val open: Int = 0,
    @SerialName("in_progress")
    val inProgress: Int = 0,
    val resolved: Int = 0,
    val closed: Int = 0
)

@Serializable
data class DashboardStatisticsStaffMetrics(
    val total: Int = 0,
    val active: Int = 0,
    val inactive: Int = 0,
    val teachers: DashboardStatisticsCountMetrics = DashboardStatisticsCountMetrics(),
    @SerialName("school_admins")
    val schoolAdmins: DashboardStatisticsCountMetrics = DashboardStatisticsCountMetrics(),
    @SerialName("school_mgmt")
    val schoolMgmt: DashboardStatisticsCountMetrics = DashboardStatisticsCountMetrics(),
    @SerialName("support_staff")
    val supportStaffRole: DashboardStatisticsCountMetrics = DashboardStatisticsCountMetrics(),
    @SerialName("school_staff")
    val supportStaff: DashboardStatisticsCountMetrics = DashboardStatisticsCountMetrics()
)
